<template>
  <div>
    <el-dialog
      title="插播视频"
      :visible.sync="dialogVisible"
      :close-on-click-modal="true"
      :before-close="viewEmbedVideoClose"
      width="80%"
    >
      <el-button v-if="list.length < 3" type="primary" size="mini" @click="search.chooseOrgVisible = true; searchData();"> 添加 </el-button>
      视频需要时间处理，请务必在开播前1小时设定；且7天后失效不可用！
      <el-row>
        <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
        >
          <el-table-column
            prop="title"
            label="标题"
            align="center"
            min-width="20%"
          ></el-table-column>

          <el-table-column label="类别" align="center" min-width="6%">
            <template slot-scope="{ row }">
              <div v-if="row.type == 2">视频</div>
              <div v-if="row.type == 4">直播回放</div>
            </template>
          </el-table-column>

          <el-table-column
            label="时长"
            align="center"
            min-width="10%"
          >
          <template slot-scope="{ row }">
              {{ durationShow(row.duration) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="created_at"
            label="添加时间"
            align="center"
            min-width="12%"
          ></el-table-column>

          <el-table-column label="操作" align="center" min-width="8%">
            <template slot-scope="{ row }">
              <el-button v-if="list.length > 1" type="danger" size="mini" @click="del(row.id)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-dialog>

    <el-dialog
      title="选择"
      :visible.sync="search.chooseOrgVisible"
      :modal="false"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="mini"
            v-model="search.query.title"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="searchData()">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        size="mini"
      >
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          min-width="20%"
        ></el-table-column>

        <el-table-column label="类别" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <div v-if="row.type == 2">视频</div>
            <div v-if="row.type == 4">直播回放</div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="时长"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            {{ durationShow(row.duration) }}
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="selectProduct(row)">
              添加
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { formatSeconds } from "@/api/common";
import { getLiveEmbedList, searchBJYVideoList, liveSetEmbedVideo, liveUnsetEmbedVideo } from "@/api/live";
export default {
  name: "liveEmbedVideo",
  props: {
  },
  data: function () {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      query: {
        page: 1,
        limit: 5,
        id: 0,
        period_id: 0,
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          title: "",
          filterPeriodIds: [],
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
  },
  methods: {
    durationShow(duration) {
      return formatSeconds(duration);
    },
    getList(id, period_id) {
      this.dialogVisible = true;
      if (id > 0) this.query.id = id;
      if (period_id > 0) this.query.period_id = period_id;
      getLiveEmbedList(this.query).then((response) => {
        this.list = response.data;
        this.search.query.filterPeriodIds = [];
        response.data.forEach((item) => {
          this.search.query.filterPeriodIds.push(item.embed_period_id);
        });
      });
    },
    viewEmbedVideoClose() {
      this.dialogVisible = false;
      this.list = [];
      this.query = {
        page: 1,
        limit: 5,
        id: 0,
        period_id: 0,
      };
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.title = "";
      this.search.query.filterPeriodIds = [];

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      this.search.query.filterPeriodIds = this.search.query.filterPeriodIds.toString();
      searchBJYVideoList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      liveSetEmbedVideo({
        id: this.query.id,
        period_id: this.query.period_id,
        embed_period_id: row.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });

      this.addEditFormOnClose();
      this.getList();
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        liveUnsetEmbedVideo({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  watch: {
  },
};
</script>

<style>
</style>